let dialogActive = false;

export function openDialog() { dialogActive = true; }
export function closeDialog() { dialogActive = false; }
export function isDialogActive() { return dialogActive; }
export function isInDialog(el: Element) { return !!el.closest('[aria-modal="true"]'); }
